import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-scale",
  "use": "foquz-icon-question-scale-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-scale\"><path d=\"M9 14a2 2 0 11-4 0 2 2 0 014 0zm0 0h12m-10 7a2 2 0 104 0m-4 0a2 2 0 114 0m-4 0H5m10 0h6M14 7a2 2 0 104 0m-4 0a2 2 0 114 0m-4 0H5m13 0h3\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol